/* Twist waitlist: handles the button with page-level event delegation, so it works even when the product block is re-rendered. Submits the real Shopify customer form (#lkc-wl-form) that sits outside the product form. */
(function () {
  function box() { return document.getElementById('lkc-waitlist'); }
  function show(b, which, msg) {
    var err = b.querySelector('[data-wl-err]');
    if (which === 'err') { err.textContent = msg; err.hidden = false; }
    else if (err) { err.hidden = true; }
  }
  function submit() {
    var b = box(); if (!b) return;
    var email = b.querySelector('[data-wl-email]'), btn = b.querySelector('[data-wl-btn]');
    var v = ((email && email.value) || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { show(b, 'err', 'Please enter a valid email address.'); if (email) email.focus(); return; }
    var f = document.getElementById('lkc-wl-form');
    var e = f && f.querySelector('[name="contact[email]"]');
    if (!f || !e) { show(b, 'err', 'Sorry, something went wrong. Please try again in a moment.'); return; }
    show(b, 'ok'); if (btn) btn.disabled = true; e.value = v;
    try { if (f.requestSubmit) f.requestSubmit(); else f.submit(); }
    catch (x) { f.submit(); }
  }
  function checkDone() {
    var b = box(); if (!b) return;
    if (/(customer_posted=true|lkc_waitlist=1)/.test(location.search)) {
      var ask = b.querySelector('[data-wl-ask]'), ok = b.querySelector('[data-wl-ok]');
      if (ask) ask.hidden = true; if (ok) ok.hidden = false;
    }
  }
  document.addEventListener('click', function (ev) {
    var t = ev.target && ev.target.closest && ev.target.closest('[data-wl-btn]');
    if (!t) return;
    ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation();
    submit();
  }, true);
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Enter') return;
    var t = ev.target && ev.target.closest && ev.target.closest('[data-wl-email]');
    if (!t) return;
    ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation();
    submit();
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', checkDone); else checkDone();
})();
